// src/components/CreateJob.tsx
import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../AuthContext';
import AlleleSearchSelect from './AlleleSearchSelect';
import { useNotifications } from '../NotificationContext';
import { BASE_URI } from '../Config';


const CreateJob: React.FC = () => {
    const [alleles, setAlleles] = useState<string[]>([]);
    const [file, setFile] = useState<File | null>(null);
    const [antigen, setAntigen] = useState('');
    const [mhc, setMhc] = useState<string | null>('');
    const [fileType, setFileType] = useState('');
    const [modelType, setModelType] = useState('Tapir');
    const inputFileRef = useRef<HTMLInputElement | null>(null);

    const { pushMessage } = useNotifications();

    const { userToken, userLineQuota } = useAuth();


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    
        const formData = new FormData();
        if (file) {
            formData.append('file', file);
        }
        formData.append('antigen', antigen);
        if (mhc) {
            formData.append('mhc', mhc);
        }
        formData.append('file_type', fileType);
        formData.append('model_type', modelType);


        console.log(mhc, fileType, modelType)
    
        try {
          const response = await fetch(`${BASE_URI}/jobs/new`, {
            method: 'POST',
            body: formData,
            headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken}`
            }

          });
    
          const data = await response.json();
          if (data.success) {
            console.log('Job created successfully');
            // window.location.reload();
            pushMessage({text: "Job created successfully!", type: "notification"});
            if (inputFileRef.current) {
                inputFileRef.current.value = '';
            }
            setFile(null);
            setAntigen('');
            setFileType('');
            setMhc(null);

          } else {
            console.error('Error creating job:', data);
            if (data.message) {
                pushMessage({text: `Problem creating job: ${data.message}`, type: "error"});
            }
            else {
                pushMessage({text: `Unexpected response, possibly due to network failure. Please try again.`, type: "error"});
            }
            
          }
        } catch (error) {
          console.error('There was an error sending the request:', error);
          pushMessage({text: "Error sending request, please try again.", type: "error"});
        }
      };

    return (
        <form onSubmit={handleSubmit}>
            <h3> Predict TCR interaction</h3>
            <div>
                <label>Choose file: </label>
                <input type="file" ref={inputFileRef} onChange={e => {
                    if (e.target.files) {
                        setFile(e.target.files[0]);
                    }
                    }}  />
            </div>
            <div>
                <label>File format <span className='light'>(less than {userLineQuota} lines)</span>: </label>
                <select value={fileType} onChange={e => setFileType(e.target.value)}>
                    <option value="" disabled selected>Select a file type</option>
                    <option value="Vcreate">Vcreate</option>
                    <option value="10x">10x</option>
                    <option value="Adaptive">Adaptive</option>
                </select>
            </div>
            <div>
                <label>Antigen: </label>
                <input type="text" value={antigen} onChange={e => setAntigen(e.target.value)} />
            </div>
            {/* <div>
                <label>MHC allele (optional): </label>
                <select value={mhc} onChange={e => {console.log("Setting mhc", e.target.value); setMhc(e.target.value) }} >
                    <option value="">Select a type</option>
                    {alleles.map(allele => <option key={allele} value={allele}>{allele}</option>)}
                </select>
            </div> */}
            <div>
                <label>MHC allele (optional): </label>
                <div className='normal'><AlleleSearchSelect onValueChange={setMhc} /></div>
            </div>
            <div>
                <label>Choose model: </label>
                <select value={modelType} onChange={e => setModelType(e.target.value)}>
                    <option value="Tapir">Tapir</option>
                    <option value="TapirPlus">TapirPlus</option>
                </select>
            </div>
            <input type="submit" value="Submit"></input>
        </form>
    );
}

export default CreateJob;